import apiService from '../services/ApiService';

import repositoryService from 'src/services/RepositoryService';

import Users from './user/userVuex';
//import Module from './module/ModuleVuex';

//TODO - USAR ALGUMA URI PARA TESTAR A CONEXÃO
//const PATH = appConfig.apiUrl() + '/api/autoComplete/models';
const state = {
  ...Users
};

const mutations = {

  ["genericMutation"] (state, payload) {
    _.set(state[payload.stateName], payload.attribute, payload.attributeValue);
  },
  ["setNewObjectState"] (state, payload) {
    let stateObject = {};
    stateObject[payload.stateName] = payload;
    Object.assign(state, stateObject);
  }
};

const actions = {

  genericMutationCommit({commit}, payload) {
    commit("genericMutation", payload)
  },

  setNewObjectStateCommit({commit}, payload) {
    commit("setNewObjectState", payload)
  },

  testConection() {
    return repositoryService.searchAutoComplete(PATH);
  },

  // Substituir por apiService.delete, ver BusinessLineShow, método _delete
  // após substituir, remover esse método
  genericDelete({}, payload) {

    let context = payload.context;
    let uri = payload.uri;
    let successRouterPush = payload.successRouterPush;

    context.$confirm(context.$t('confirmTheDeletion'), context.$t('warning'), {
      confirmButtonText: context.$t('yes'),
      cancelButtonText: context.$t('no'),
      type: 'warning'
    }).then(() => {

      repositoryService.deleteInstance(PATH + uri)
        .then((response) => {

          if (response.meta.code == 200) {

            context.$notify({
              title: context.$t('success'),
              message: 'Item removido.',
              type: 'success'
            });

            if (successRouterPush != undefined) {
              context.$router.push(successRouterPush);
            }

          } else {

            let errorMessage = response.errors[0].message

            if (errorMessage == "") {
              errorMessage = response.errors[0]["error-code"]
            }

            context.$alert(
              errorMessage,
              'Erro',
              {
                confirmButtonText: 'Fechar',
                type: 'error'
              }
            );
          }
        });

    });
  },

  setItemsPerPage({dispatch}, payload) {

    return dispatch("genericMutationCommit", {
      stateName: payload.stateName,
      attribute: "filter.currentPage",
      attributeValue: 1
    }).then(() => {

      return dispatch("genericMutationCommit", {
        stateName: payload.stateName,
        attribute: "filter.itemsPerPage",
        attributeValue: payload.filter.itemsPerPage
      });

    }).then(() => {
      return dispatch("search", payload);
    });
  },

  setPage({dispatch}, payload) {

    return dispatch("genericMutationCommit", {
      stateName: payload.stateName,
      attribute: "filter.currentPage",
      attributeValue: payload.filter.currentPage
    }).then(() => {
      return dispatch('search', payload);
    });
  },

  doSearch({dispatch}, payload) {

    return Promise.resolve().then(() => {
      if (payload.clickFromButton) {
        return dispatch("genericMutationCommit", {
          stateName: payload.stateName,
          attribute: "filter.currentPage",
          attributeValue: 1
        });
      }
    }).then(() => {
      return dispatch("genericMutationCommit", {
        stateName: payload.stateName,
        attribute: "submitted",
        attributeValue: true
      });
    }).then(() => {
      return dispatch("genericMutationCommit", {
        stateName: payload.stateName,
        attribute: "filter",
        attributeValue: Object.assign(
          {}, state[payload.stateName].filter, payload.filter
        )
      });
    }).then(() => {
      return dispatch("search", payload)
    });
  },

  search({dispatch, getters}, payload) {

    dispatch("showLoader");

    return apiService.search(
      getters.retrieveState(payload.stateName)
    ).then(response => {

      dispatch("genericMutationCommit", {
        stateName: payload.stateName,
        attribute: "pagination",
        attributeValue: response.pagination
      });

      return dispatch("genericMutationCommit", {
        stateName: payload.stateName,
        attribute: "list",
        attributeValue: response.data
      });

    }).then(() => {
      return dispatch('hideLoader');
    });
  },

  fetch({}, payload) {
    return apiService.fetch(payload)
  },

  delete({}, payload) {
    return apiService.delete(payload);
  },

  save({}, payload) {
    apiService.save(payload);
  }
};

const getters = {
  retrieveState: (state) => (stateName) => {
    let tr = state[stateName];
    if (tr === undefined) {
      return undefined;
    }
    return Object.assign({}, tr);
  },
  list: (state) => (payload) => {
    let stateFound = state[payload.stateName];
    return (stateFound !== undefined) ? stateFound.list : [];
  },
  pagination: (state) => (payload) => {
    if (payload.stateName !== undefined && payload.stateName !== '') {
      if(state[payload.stateName] !== undefined) {
        return state[payload.stateName].pagination;
      }
    }
    return {};
  },
  apiUrl: () => {
    return apiService.apiUrl();
  },
  showBottomPagination: (state) => (payload) => {
    let pagination = state[payload.stateName].pagination;
    return (pagination.totalPage > 1);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/AppVuex.js